module.exports = __webpack_public_path__ + "img/fi-street-food-1200x790.39541e7e.jpg";